import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import classNames from 'classnames';
import { storyblokEditable } from 'gatsby-source-storyblok';

interface SpacerBlokProps extends Blok {
  theme: Theme;
  size: 'sm' | 'md' | 'lg';
}

interface SpacerProps {
  blok: SpacerBlokProps;
}

const Spacer: React.FC<SpacerProps> = ({ blok }) => {
  const { size } = blok;

  return (
    <div
      {...storyblokEditable(blok)}
      className={classNames({
        'h-6 md:h-10': size === 'sm',
        'h-10 md:h-16': size === 'md',
        'h-16 md:h-20': size === 'lg',
      })}
    />
  );
};

export default memo(withBlokWrapper(Spacer));
